exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1ajpnHYQYLKcLp8_GfEirx ._9z2s7B43kBG2T6PPRQl8o{display:inline-block}", ""]);
// Exports
exports.locals = {
	"monaco-editor": "_1ajpnHYQYLKcLp8_GfEirx",
	"vs-whitespace": "_9z2s7B43kBG2T6PPRQl8o"
};